import { ResultOf } from 'gql.tada';
import { weblinkFragment } from '../../../../graphql/fragments/weblinkFragment';
import { mapApiWeblinkIconInfoToLinkIconInfo } from '../../../helpers/mapApiWeblinkIconInfoToLinkIconInfo';
import { mapApiWeblinkVariantToLinkVariant } from '../../../helpers/mapApiWeblinkVariantToLinkVariant';
import { WebLinkProps } from '../WebLink';

export type ApiWebLink = ResultOf<typeof weblinkFragment>;

export const mapApiWebLinkToWebLinkProps = (webLink: ApiWebLink): WebLinkProps => {
  return {
    title: webLink.title,
    url: webLink.url,
    isExternal: webLink.isExternal,
    variant: mapApiWeblinkVariantToLinkVariant(webLink.variant),
    iconInfo: webLink.iconInfo ? mapApiWeblinkIconInfoToLinkIconInfo(webLink.iconInfo) : null,
    ...(webLink.rel && { rel: webLink.rel }),
    tracking: {
      outboundTracking: webLink.tracking?.outboundTracking
        ? {
            schema: webLink.tracking.outboundTracking.schema,
            data: {
              event_name: webLink.tracking.outboundTracking.data.event_name,
              type: webLink.tracking.outboundTracking.data.type,
              click_url: webLink.tracking.outboundTracking.data.click_url,
            },
          }
        : null,
      clickThroughTracking: webLink.tracking?.clickThroughTracking
        ? {
            pathname: webLink.tracking.clickThroughTracking.pathname,
            page: webLink.tracking.clickThroughTracking.page,
            element: webLink.tracking.clickThroughTracking.element,
            sourceType: webLink.tracking.clickThroughTracking.sourceType,
          }
        : null,
    },
    ...(webLink.key && { key: webLink.key }),
    ...(webLink.rel && { rel: webLink.rel }),
    ...(typeof webLink.disabled === 'boolean' && { disabled: webLink.disabled }),
  };
};
